import { render, staticRenderFns } from "./RelationshipSimple.vue?vue&type=template&id=b4ef30e8&"
import script from "./RelationshipSimple.vue?vue&type=script&lang=js&"
export * from "./RelationshipSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports